export enum FormNameEnum {
    SIGNUP = "signup",
    LOGIN = "login",
    CONTACT = "contact",
    ACCOUNT_PASSWORD = "accountpassword",
    ACCOUNT_USERNAME = "accountusername",
    FORGOTTEN_PASSWORD = "forgottenpassword",
    ADMIN_USER_UPDATE = "adminuserupdate",
    ADMIN_USER_CREATE = "adminusercreate",
    PROGRAM_COMMENT = "programcomment",
    PROGRAM_VIDEO = "programvideo"
}

export namespace FormNameEnum {
    export const valueOf = (formName?: string): FormNameEnum | undefined => {
        try {
            return formName != null ? FormNameEnum[formName] : undefined
        } catch(e) {
            return undefined
        }
    }

    export const isFormName = (formName?: string):boolean => {
        return FormNameEnum.valueOf(formName) != null
    }

    export const toArray = (): Array<FormNameEnum> => {
        return Object.values(FormNameEnum).map(f => f as FormNameEnum).filterNull()
    }
}
